import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";

import PerfilSellerListUsuario from './ListUsuario';
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../hooks/snackBar';
import {
    listarUsuarioSeller,
    listarUsuarioSellerComFiltro,
    gerarRelatorioUsuariosSeller
} from '../../../services/http/SellerAdminstradorService/usuarioSellerService';

import services from '../../../services';

import { saveAs } from 'file-saver';
import './styles.scss';

const PerfilSellerUsuario = () => {
    const history = useHistory();
    const { idSeller } = services.storage.getUser();
    const { addSnackBar } = useSnackBar();
    const [busca, setBusca] = useState('');
    const [usuarios, setUsuarios] = useState(
        {
            numeroPagina: 0,
            totalPaginas: 0,
            lista: [],
            tamanhoPagina: 0,
            hasPreviousPage: false,
            hasNextPage: false
        });

    const CarregarListaUsuarios = (pagina) => {
        trackPromise(
            listarUsuarioSeller(idSeller, pagina)
                .then(res => {
                    if (res.data) {
                        setUsuarios(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar usuários', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar usuários', info: 'error', open: true });
        })
    }

    const CarregarListaUsuarioComFiltro = (filtro, pagina) => {
        trackPromise(
            listarUsuarioSellerComFiltro(filtro, idSeller, pagina)
                .then(res => {
                    if (res.data) {
                        setUsuarios(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar Usuario', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar Usuario', info: 'error', open: true });
        })
    }

    const extrairBaseUsuariosSeller = () => {
        trackPromise(
            gerarRelatorioUsuariosSeller(idSeller)
                .then(res => {
                    if (res.data) {
                        saveAs(res.data, "usuarios-seller.xlsx")

                    } else {
                        addSnackBar({ message: 'Não foi possível extrair a base com usuários', info: 'warning', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano extrair a base com usuários', info: 'error', open: true });
        })
    }

    const mudarPaginaUsuarioSeller = (page) => {
        busca != "" ? CarregarListaUsuarioComFiltro(busca, page) : CarregarListaUsuarios(page);
    }

    const buscar = (filtro) => {
        setBusca(filtro);
    }

    useEffect(() => {
        if (busca != "") {
            const delayDebounceFn = setTimeout(() => {
                CarregarListaUsuarioComFiltro(busca, 1);
            }, 2000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            CarregarListaUsuarios(1);
        }

    }, [busca]);

    useEffect(() => {
        CarregarListaUsuarios(1)
    }, []);

    return (
        <div>
            <div className='row mt-1 ml-1 titulo'>
                Usuários
            </div>
            <div className='row mt20  ml-1 '>
                <h1 className='label-second'>Cadastro de Usuários</h1>
            </div>

            <div className='row'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button onClick={() => history.push('/seller/usuario/cadastro')} className="buton-green btn btn-block btn-lg mt20">
                        NOVO USUÁRIO
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button onClick={() => extrairBaseUsuariosSeller()} className="buton-white-black-border btn btn-block btn-lg mt20">
                        EXTRAIR BASE
                    </button>
                </div>
            </div>

            <PerfilSellerListUsuario
                response={usuarios}
                mudarPagina={mudarPaginaUsuarioSeller}
                buscar={buscar}
                busca={busca}
            />

        </div>
    );
}

export default PerfilSellerUsuario;